import axios from 'axios';
import { ajaxUri } from '../../../consts/index';

export const fetchTemplates = (loadIncrement = null,cb = () => {}) => {    
    return dispatch => {
        axios({
			method: 'post',
			url: ajaxUri,
			data: {
				request : 'listLayouts'
			}
		})
		.then(result => {
            if( loadIncrement ) dispatch({type:'LOAD_INCREMENT',toAdd:parseInt(loadIncrement)})
            
            dispatch({type:'LIST_TEMPLATES',templates:result.data});
            cb();
		}).catch(error => {
            dispatch({type:'LIST_TEMPLATES',templates:[]});
        });
    }
}